import { memo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { triggerGAEvent } from "../../../utils/helper";

const Analytics = () => {
  const layersLoading = useSelector((store) => store.layersLoading);
  const initialized = useRef(false);

  // Set up event listeners when layers are loaded
  useEffect(() => {
    if (layersLoading || initialized.current) return;

    // Mark as initialized to prevent future setups
    initialized.current = true;

    const handleGtagEvent = (event) => {
      if (window.gtag && process.env.NODE_ENV === "production") {
        const tagName = event?.target?.dataset?.tagName;

        if (!tagName || event?.target?.ariaExpanded === "true") return;
        triggerGAEvent({
          event: "widget",
          params: {
            widget_name: tagName,
          },
        });
      }
    };

    document.querySelectorAll(".gtag").forEach((element) => {
      element.addEventListener("click", handleGtagEvent);
    });

    return () => {
      document.querySelectorAll(".gtag").forEach((element) => {
        element.removeEventListener("click", handleGtagEvent);
      });
    };
  }, [layersLoading]);

  // Return null as this component doesn't render anything
  return null;
};

export default memo(Analytics);
